import { Button, ComposedModal, Form, ModalBody, ModalFooter, ModalHeader, Stack, TextInput } from "@carbon/react";
import { useEffect } from "react";

const EditProfileModal = ({ 
    isOpen, 
    onClose, 
    formData, 
    onChange, 
    onSave, 
    updateLoading, 
    profileUser 
}) => {
    const handleChange = (field) => (e) =>
        onChange(prev => ({ ...prev, [field]: e.target.value }));

    useEffect(() => {
        if (isOpen && profileUser) {
            // Reset form when modal opens
            onChange({
                username: profileUser.username || '',
                first_name: profileUser.first_name || '',
                last_name: profileUser.last_name || ''
            });
        }
    }, [isOpen, profileUser, onChange]);

    useEffect(() => {
        if (!isOpen) {
            // Reset form when modal closes
            onChange({ username: '', first_name: '', last_name: '' });
        }
    }, [isOpen, onChange]);

    return (
        <ComposedModal className="profile-modal" open={isOpen} onClose={onClose} size="md">
            <ModalHeader title="Editar Perfil" />
            <ModalBody>
                <Form>
                    <Stack gap={5}>
                        <TextInput 
                            labelText='Nombre usuario' 
                            id='input-username'
                            value={formData.username}
                            onChange={handleChange('username')} 
                        />
                        <TextInput 
                            labelText='Nombre' 
                            id='input-first-name'
                            value={formData.first_name}
                            onChange={handleChange('first_name')}
                        />
                        <TextInput 
                            labelText='Apellidos' 
                            id='input-last-name'
                            value={formData.last_name}
                            onChange={handleChange('last_name')}
                        />
                    </Stack>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button kind="danger" size="md" onClick={onClose}>
                    Cancelar
                </Button>
                <Button
                    kind="primary"
                    size="md"
                    disabled={updateLoading}
                    onClick={onSave}
                >
                    {updateLoading ? 'Guardando...' : 'Guardar'}
                </Button>
            </ModalFooter>
        </ComposedModal>
    );
};

export default EditProfileModal;
